import axios from 'axios';
import api from './api';

// Sử dụng cấu hình chung từ config.js
const BACKEND_API_URL = window.AMS_CONFIG?.API_URL || process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
const API_PATH = window.AMS_CONFIG?.API_PATH || '/api';
const API_BASE_URL = `${BACKEND_API_URL}${API_PATH}`;

console.log('AuthAPI - Using API configuration:', { BACKEND_API_URL, API_PATH, API_BASE_URL });

// Cache for getCurrentUser to prevent duplicate calls
let userCache = null;
let userPromise = null;

// Temporary compatibility function - does nothing since interceptors are now set up in api.js
export const setupAuthInterceptor = () => {
  console.log('setupAuthInterceptor called but not needed anymore - interceptors are configured in api.js');
  // Function is kept for backward compatibility
  return;
};

// Auth API endpoints
const authApi = {
  // Login user - Updated to use correct Django endpoint
  login: (credentials) => {
    console.log('Attempting login with credentials:', {
      username: credentials.username,
      password: credentials.password ? '******' : 'empty'
    });
    return api.post('/auth/login/', credentials)
      .catch(error => {
        console.error('Login error:', error);
        throw error;
      });
  },
  
  // Refresh token - Updated to use correct Django endpoint
  refreshToken: (refreshToken) => 
    api.post('/auth/token/refresh/', { refresh: refreshToken }),
  
  // Logout user
  logout: () => {
    const refreshToken = localStorage.getItem('refreshToken');
    console.log('Attempting to logout');
    
    // Clear user cache on logout
    userCache = null;
    userPromise = null;
    
    // Try the backend logout endpoint
    return api.post('/auth/logout/', { refresh: refreshToken })
      .catch(error => {
        console.log('No logout endpoint available, just removing tokens');
        return Promise.resolve({ data: { success: true } });
      });
  },
  
  // Get current user info
  getCurrentUser: () => {
    console.log('Fetching current user info');
    
    // Use cache if available and not expired (2 minutes)
    if (userCache && (Date.now() - userCache.timestamp < 2 * 60 * 1000)) {
      console.log('Using cached user data');
      return Promise.resolve(userCache.data);
    }
    
    // If already loading, return the existing promise
    if (userPromise) {
      console.log('User request already in progress, waiting...');
      return userPromise;
    }
    
    // Create new promise
    userPromise = api.get('/users/me/')
      .then(response => {
        // Cache the response
        userCache = {
          data: response,
          timestamp: Date.now()
        };
        return response;
      })
      .finally(() => {
        userPromise = null; // Clear promise after completion
      });
    
    return userPromise;
  },
  
  // Register new user (if applicable)
  register: (userData) => 
    axios.post(`${API_BASE_URL}/users/`, userData),
  
  // Update user profile
  updateUserProfile: (userData) => 
    api.patch('/users/me/', userData),
  
  // Update password
  updatePassword: (passwordData) => {
    const { current_password, new_password } = passwordData;
    return api.post('/users/change-password/', {
      current_password,
      new_password,
    });
  },
    
  // Request password reset
  requestPasswordReset: (email) => 
    api.post('/users/request-password-reset/', { email }),
    
  // Confirm password reset
  confirmPasswordReset: (data) => 
    api.post(`/users/reset-password/${data.token}/`, { new_password: data.new_password }),
};

// Note: We don't need to set up interceptors here anymore
// as they're already set up in the api.js file

export default authApi; 